import React from 'react'

export default function Vehicle({className}) {
    return (
        <svg 
        className={`${className} w-8 h-8 text-gray-700`} 
        
        //  className="w-6 h-6 text-gray-800 dark:text-white" 
         aria-hidden="true" 
         xmlns="http://www.w3.org/2000/svg" 
         width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
        <path fillRule="evenodd" d="M4 4a2 2 0 0 0-2 2v9a1 1 0 0 0 1 1h.535a3.5 3.5 0 1 0 6.93 0h3.07a3.5 3.5 0 1 0 6.93 0H21a1 1 0 0 0 1-1v-4a.999.999 0 0 0-.106-.447l-2-4A1 1 0 0 0 19 6h-5a2 2 0 0 0-2-2H4Zm14.192 11.59.016.02a1.5 1.5 0 1 1-.016-.021Zm-10 0 .016.02a1.5 1.5 0 1 1-.016-.021Zm5.806-5.572v-2.02h4.396l1 2.02h-5.396Z" clipRule="evenodd"/>
      </svg>
      


    )
}
